/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignAddonStorePathParams,
	CampaignAddonStoreRequest,
	CampaignAddonStoreResponse,
} from '../types/CampaignAddonStore'

/**
 * POST /campaigns/:campaign/addon/:addon
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAddonController.php CampaignAddonController::store
 */
export async function campaignAddonStore(
	campaign: CampaignAddonStorePathParams['campaign'],
	addon: CampaignAddonStorePathParams['addon'],
	data: CampaignAddonStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignAddonStoreResponse>> {
	return axiosInstance.post(`/campaigns/${campaign}/addon/${addon}`, data, config)
}
